export type ClientPlanAssignmentType = "catalog" | "pending" | "enterprise";

export interface ClientPlanSummary {
  assignment_type: ClientPlanAssignmentType;
  plan_id: string | null;
  plan_name: string | null;
  display_label: string;
  monthly_call_limit?: number | string | null;
  monthly_token_limit?: number | string | null;
  excess_rate_per_1m_tokens?: number | string | null;
}

export interface ClientWithPlanFields {
  plan_id?: string | null;
  plan?: {
    id: string | null;
    name: string;
    monthly_call_limit?: number | string;
    monthly_token_limit?: number | string;
    excess_rate_per_1m_tokens?: number | string;
  } | null;
  plan_summary?: ClientPlanSummary | null;
}

export const PENDING_PLAN_LABEL = "Configuração pendente";
export const ENTERPRISE_PLAN_LABEL = "Enterprise";

export function getClientPlanSummary(
  client: ClientWithPlanFields | null | undefined
): ClientPlanSummary {
  if (client?.plan_summary) {
    return client.plan_summary;
  }

  if (
    !client?.plan_id &&
    client?.plan?.name?.toLowerCase() === "enterprise"
  ) {
    return {
      assignment_type: "enterprise",
      plan_id: null,
      plan_name: ENTERPRISE_PLAN_LABEL,
      display_label: ENTERPRISE_PLAN_LABEL,
      monthly_call_limit: client.plan.monthly_call_limit ?? null,
      monthly_token_limit: client.plan.monthly_token_limit ?? null,
      excess_rate_per_1m_tokens: client.plan.excess_rate_per_1m_tokens ?? null,
    };
  }

  if (client?.plan_id && client.plan?.name) {
    return {
      assignment_type: "catalog",
      plan_id: client.plan_id,
      plan_name: client.plan.name,
      display_label: client.plan.name,
      monthly_call_limit: client.plan.monthly_call_limit ?? null,
      monthly_token_limit: client.plan.monthly_token_limit ?? null,
      excess_rate_per_1m_tokens: client.plan.excess_rate_per_1m_tokens ?? null,
    };
  }

  return {
    assignment_type: "pending",
    plan_id: null,
    plan_name: null,
    display_label: PENDING_PLAN_LABEL,
  };
}

export function formatPlanRate(value?: number | string | null): string {
  if (value === null || value === undefined || value === "") return "—";
  const num = Number(value);
  if (Number.isNaN(num)) return String(value);
  return num.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatPlanInteger(value?: number | string | null): string {
  if (value === null || value === undefined || value === "") return "—";
  const num = Number(value);
  if (Number.isNaN(num)) return String(value);
  return num.toLocaleString("pt-BR");
}
